import { IdType, ImportType } from 'modules/domains/adminApp';

export enum FormFieldKey {
  IdType = 'idType',
  ImportType = 'importType',
  ChangeComment = 'changeComment',
}

export type FormState = {
  [FormFieldKey.IdType]: IdType;
  [FormFieldKey.ImportType]: ImportType;
  [FormFieldKey.ChangeComment]: string;
};

export type FractionEnabled = number;

export type Fractions = {
  [projectOrOrgId: number]: FractionEnabled;
};

export type SubmitSuccessHandlerFn = (formState: FormState) => void;

export type ImportIdsToFeatureFlagRequestBody = {
  currentVersion: number;
  comment: string;
  notes?: string;
  idType: IdType;
  importType: ImportType;
};

export type ImportIdsToFeatureFlagResponseBody = {
  feature: string;
  createdAt: number;
  version: number;
  authorUserId: string;
  changes: string[];
  comment: string;
  authorEmail: string;
};
